import {
  FETCH_PACKAGES_REQUEST,
  FETCH_PACKAGES_SUCCESS,
  FETCH_PACKAGES_FAILURE,
  ADD_SIZE_ESTIMATE_REQUEST,
  ADD_SIZE_ESTIMATE_SUCCESS,
  ADD_SIZE_ESTIMATE_FAILURE,
  FETCH_SIZE_ESTIMATES_REQUEST,
  FETCH_SIZE_ESTIMATES_SUCCESS,
  FETCH_SIZE_ESTIMATES_FAILURE,
  FETCH_ALL_SIZE_ESTIMATES_REQUEST,
  FETCH_ALL_SIZE_ESTIMATES_SUCCESS,
  FETCH_ALL_SIZE_ESTIMATES_FAILURE,
  UPDATE_SIZE_ESTIMATE_REQUEST,
  UPDATE_SIZE_ESTIMATE_SUCCESS,
  UPDATE_SIZE_ESTIMATE_FAILURE,
  SET_CLAIM_FORM_ACTIVATION_REQUEST,
  SET_CLAIM_FORM_ACTIVATION_SUCCESS,
  SET_CLAIM_FORM_ACTIVATION_FAILURE,
} from '../actions/types';

const initialState = {
  packages: [],
  loading: false,
  error: null,
  message: '',
  sizeEstimates: [],
  allSizeEstimates: [],
};

// Reducer for handling actions
export default function packageReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PACKAGES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_PACKAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        packages: action.payload,
        message: 'Packages loaded successfully',
      };

    case FETCH_PACKAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        packages: [],
      };

    // Handling add size estimate actions
    case ADD_SIZE_ESTIMATE_REQUEST:
      return { ...state, loading: true, error: null };

    case ADD_SIZE_ESTIMATE_SUCCESS:
      return {
        ...state,
        loading: false,
        sizeEstimates: action.payload,
        message: 'Size estimate added successfully',
      };

    case ADD_SIZE_ESTIMATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        sizeEstimates: null,
      };

    // Handling fetch size estimates actions
    case FETCH_SIZE_ESTIMATES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_SIZE_ESTIMATES_SUCCESS:
      return {
        ...state,
        loading: false,
        sizeEstimates: action.payload,
        message: 'Size estimates fetched successfully',
      };

    case FETCH_SIZE_ESTIMATES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        sizeEstimates: null,
      };

    // Handling update size estimate actions
    case UPDATE_SIZE_ESTIMATE_REQUEST:
      return { ...state, loading: true, error: null };

    case UPDATE_SIZE_ESTIMATE_SUCCESS:
      return {
        ...state,
        loading: false,
        allSizeEstimates: state.allSizeEstimates.map((estimate) =>
          estimate.size_category === action.payload.size_category ? action.payload : estimate
        ),
        message: 'Size estimate updated successfully',
      };

    case UPDATE_SIZE_ESTIMATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    // Handling fetch all size estimates actions (not by category)
    case FETCH_ALL_SIZE_ESTIMATES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_ALL_SIZE_ESTIMATES_SUCCESS:
      return {
        ...state,
        loading: false,
        allSizeEstimates: action.payload,
        message: 'All size estimates fetched successfully',
      };

    case FETCH_ALL_SIZE_ESTIMATES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        allSizeEstimates: [],
      };

        case SET_CLAIM_FORM_ACTIVATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case SET_CLAIM_FORM_ACTIVATION_SUCCESS: {
      const updatedPackage = action.payload; 

      return {
        ...state,
        loading: false,
        error: null,
        message: 'Claim form activation updated successfully',

        packages: state.packages.map((pkgWrapper) => {
          if (pkgWrapper?.package?.package_id === updatedPackage.package_id) {
            return {
              ...pkgWrapper,
              package: updatedPackage,
            };
          }
          return pkgWrapper;
        }),
      };
    }

    case SET_CLAIM_FORM_ACTIVATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
